// extracted by mini-css-extract-plugin
export default {"wrapper":"Cur6JbHjlsIk3C0_yhE9","link":"ME2CskIZputlkyO7jOdw","nameRow":"KH8xiVx8JvEWMNoiAFyj","name":"CBFvkIXR1I0DYNvcIK08","contactInfo":"DkVdzKrhaUnqRMN80UuQ"};